import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../_shared/shared.module';
import { ResultsRoutingModule } from './results.routing';
import { DatepickerModule } from '../_globals';
import { DocumentService } from '../_services';
import { ResultsComponent }   from './results.component';
import { DocumentListComponent } from './document-list/document.list.component';
import { FilterMenuComponent } from './filter-menu/filter.menu.component';
import { ImageResultsComponent} from './image-results/image.results.component';
import { ImageListComponent } from './image-list/image.list.component';
import { PaginationComponent } from './pagination/pagination.component';

import {
  SearchService,
  SearchFilterService,
  ResourceTypeService,
  SortOptionService,
  LimitOptionService,
  PubDateOptionService
} from '../_services';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    DatepickerModule,
    ResultsRoutingModule,
    FormsModule,
    SharedModule
  ],
    exports: [

    ],
  declarations: [
    ResultsComponent,
    DocumentListComponent,
    FilterMenuComponent,
    ImageResultsComponent,
    ImageListComponent,
    PaginationComponent,
  ],
  providers: [
    SearchService,
    SearchFilterService,
    ResourceTypeService,
    SortOptionService,
    LimitOptionService,
    PubDateOptionService,
    DocumentService
  ],
})
export class ResultsModule {}
